export default __webpack_public_path__ + "static/inn-bubble-3-4a8cf4be33ba2862e9e57aaa7054c3b8.svg";